import { render, staticRenderFns } from "./ShareCVDialog.vue?vue&type=template&id=2d7edb78"
import script from "./ShareCVDialog.vue?vue&type=script&lang=js"
export * from "./ShareCVDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports